import { ANALYTIC_COOKIES } from './constants'
import getCookie from './getCookie'
import isBrowser from './isBrowser'

const getUtmParameters = () => {
  if (isBrowser()) {
    const utm_source = getCookie(ANALYTIC_COOKIES.UTM_SOURCE) ?? getCookie(ANALYTIC_COOKIES.UTM_SOURCE_SERVER)
    const utm_medium = getCookie(ANALYTIC_COOKIES.UTM_MEDIUM) ?? getCookie(ANALYTIC_COOKIES.UTM_MEDIUM_SERVER)
    const utm_campaign = getCookie(ANALYTIC_COOKIES.UTM_CAMPAIGN) ?? getCookie(ANALYTIC_COOKIES.UTM_CAMPAIGN_SERVER)
    const utm_content = getCookie(ANALYTIC_COOKIES.UTM_CONTENT) ?? getCookie(ANALYTIC_COOKIES.UTM_CONTENT_SERVER)
    const utm_term = getCookie(ANALYTIC_COOKIES.UTM_TERM) ?? getCookie(ANALYTIC_COOKIES.UTM_TERM_SERVER)
    const qclid = getCookie(ANALYTIC_COOKIES.QCLID) ?? getCookie(ANALYTIC_COOKIES.QCLID_SERVER)
    return { utm_source, utm_medium, utm_campaign, utm_content, utm_term, qclid }
  }
  return {}
}

export default getUtmParameters
